import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete, Box, Card, CardContent, CardMedia, IconButton, Modal, Skeleton, TextField, Typography, useMediaQuery } from '@mui/material';
import { formSnackbar } from '../../../../_services/_constants/snackbar.constant';
import { setSnackBar, setSnackBarMessage, setSnackBarVariant } from '../../../../redux';
import { getStrPlatformImg } from '../../../../_helpers/reusablefunctions/getStreamingPlatform';
import { useParams } from 'react-router-dom';
import ApiService from '../../../../_services/ApiService';
import { getStreamingPlatforms } from '../../../../_services/creater/streamingPlatform.service';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import DeleteIcon from '@mui/icons-material/Delete';
import useSnackDispatcher from '../../../../_helpers/reusablefunctions/snackBarComponent';
import imgThumbnail from '../../../../img/thumbnail.png';
import { isValidUUID } from '../../../../_helpers/reusablefunctions/urlValidator';

function PlaylistPlatforms({ provided, playlistSongLibrary, allplaylistSongLibrary, getPlaylistData, index, setPlaylistSongLibrary }) {
  const { successSnack, errorSnack, warningSnack, infoSnack } = useSnackDispatcher();
  let { playlistId } = useParams();
  const dispatch = useDispatch()
  const userData = useSelector((state) => state.userData.userData);
  const streamingPlatform = useSelector((state) => state.streamingPlatform.streamingPlatform);
  const [selectedStatus, setSelectedStatus] = useState(true);
  const [streamingLink, setStreamingLink] = useState('')
  const [selectedPlatform, setSelectedPlatform] = useState('')
  const [platformLogo, setPlatformLogo] = useState(imgThumbnail)
  const [allPlatfromList, setAllPlatformList] = useState([])
  const [error, setError] = useState(false);

  useEffect(() => {
    if (streamingPlatform.length) {
      setAllPlatformList(streamingPlatform)
      removeMatchedPlatfrom('remove')

    }
  }, [streamingPlatform])

  const removeMatchedPlatfrom = (action, value) => {
    let localDataBKP = [...streamingPlatform]
    if (action == 'remove') {
      setAllPlatformList(localDataBKP.filter(entry1 => entry1.platform_key !== "Instagrammakereels" && !allplaylistSongLibrary.some(entry2 => entry1?.platformName === entry2.platformName)))
    }
    if (action == 'update') {
      setAllPlatformList(localDataBKP.filter(entry1 => entry1.platformId !== value.platformId))
    }
  }

  useEffect(() => {
    playlistSongLibrary.platformName = playlistSongLibrary?.streamingPlatformName
    if (playlistSongLibrary.platformName) {
      setSelectedStatus(playlistSongLibrary?.status)
      setStreamingLink(playlistSongLibrary?.streamingPlatformlink || '')
      setSelectedPlatform(playlistSongLibrary || '')
      setPlatformLogo(getStrPlatformImg(playlistSongLibrary?.streamingPlatformKey) || '')
    }
  }, [playlistSongLibrary])

  const createRelatedPlatformLink = (postObj) => {
    postObj.userId = userData.id;
    postObj.playlistId = playlistId;
    postObj.status = selectedStatus ? "True" : "False"
    infoSnack(formSnackbar.relatedPlatform.realtedPlatformCreate)
    ApiService.post('platformCreateUpdateDelte', postObj).then((response) => {
      if (response.status === 200) {
        successSnack(formSnackbar.relatedPlatform.realtedPlatformCreateSuccess)
        getPlaylistData()
      }
      if (response.status == 400) {
        dispatch(setSnackBarMessage(response?.data?.error[0] || response?.data?.streamingPlatformlink));
        dispatch(setSnackBarVariant('error'));
        setTimeout(() => {
          dispatch(setSnackBar(false));
        }, 2000);
      }
    }).catch(error => {
      console.log(error)
      errorSnack(formSnackbar.errors.errorMsg)
    })
  }

  function updateRelatedPlatformLink(postObj) {
    postObj.userId = userData.id;
    postObj.playlistId = playlistId;
    infoSnack(formSnackbar.relatedPlatform.realtedPlatformUpdate)
    ApiService.put('platformCreateUpdateDelte', postObj, { id: playlistSongLibrary?.id }).then((response) => {
      if (response.status === 200) {
        successSnack(formSnackbar.relatedPlatform.realtedPlatformUpdateSuccess)
        getPlaylistData()
      }
      if (response.status == 400) {
        dispatch(setSnackBarMessage(response?.data?.error[0] || response?.data?.streamingPlatformlink));
        dispatch(setSnackBarVariant('error'));
        setTimeout(() => {
          dispatch(setSnackBar(false));
        }, 2000);
      }
    }).catch(error => {
      console.log(error)
      errorSnack(formSnackbar.errors.errorMsg)
    })
  }

  const platformStatusChangeHandler = (e, platformId) => {
    setSelectedStatus(e.target.checked);
    userData.id && platformId == undefined
      ? createRelatedPlatformLink({
        status: e.target.checked ? "True" : "False",
      })
      : updateRelatedPlatformLink({
        status: e.target.checked ? "True" : "False",
      });
  };

  const platformChangeHandler = (e, newValue, platformId) => {
    e.preventDefault();
    if (newValue) {
      let newplatformLogo = getStrPlatformImg(newValue?.platform_key);
      setPlatformLogo(newplatformLogo)
      removeMatchedPlatfrom('update', newValue)
      if (userData.id) {
        if (isValidUUID(platformId)) {
          createRelatedPlatformLink({
            streamingPlatform: newValue?.platformId,
          })
        } else {
          updateRelatedPlatformLink({
            streamingPlatform: newValue?.platformId,
          });
        }
      }
      setSelectedPlatform(newValue);
    }
  };
  const isValidURL = (url) => {
    let regex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
    return regex.test(url);
  };
  const playlistPlatformChangeHandler = (e, data) => {
    e.preventDefault();
    const { value } = e.target
    setStreamingLink(value)
    if (e.type == 'blur' && value) {
      if (!isValidURL(value)) {
        setError(true);
        return;
      }
      setError(false);
      userData.id && data.id == undefined
        ? createRelatedPlatformLink({
          streamingPlatformlink: value
        })
        : updateRelatedPlatformLink({
          streamingPlatformlink: value
        });
    }
  }

  const deletePlatformHanlder = (id) => {
    if (id) {
      if (!isValidUUID(id)) {
        ApiService.delete('platformCreateUpdateDelte', { id: id }).then((response) => {
          successSnack(formSnackbar.relatedPlatform.relatedPlatformDeleteSuccess)
          getPlaylistData()
        }).catch(error => {
          errorSnack(formSnackbar.errors.errorMsg)
          console.log(error)
        })
      } else {
        const deletePlatform = allplaylistSongLibrary.filter((_, i) => i !== index);
        setPlaylistSongLibrary(deletePlatform)
      }
    }
  }

  return (
    <Box width={'100%'} ref={provided.innerRef} {...provided.draggableProps}>
      <Card className='m-3'>
        <CardContent className='p-2'>
          <Box
            display="flex"
            flexDirection={{ xs: 'column', sm: 'row' }} // Responsive
            alignItems={{ xs: 'stretch', sm: 'center' }}
            gap={2}
          >
            <Box className="drag-hanlder" {...provided.dragHandleProps}>
              <DragIndicatorIcon />
            </Box>

            <CardMedia
              component="img"
              sx={{
                width: '50px',
                height: '50px',
                borderRadius: '100%',
                // alignSelf: { xs: 'center', sm: 'flex-start' }
              }}
              image={platformLogo}
            />

            <Box width={{ xs: '100%', sm: '90%' }}>
              <Autocomplete
                options={allPlatfromList}
                getOptionLabel={(option) => option.platformName || ''}
                id="controlled-demo"
                value={selectedPlatform || null}
                onChange={(e, value) => platformChangeHandler(e, value, playlistSongLibrary?.id)}
                size="small"
                sx={{ padding: '5px' }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{ '&>div': { paddingRight: '0px !important' } }}
                    placeholder="Add platform"
                    variant="standard"
                    color="secondary"
                  />
                )}
              />

              <TextField
                id="platforms-id"
                onChange={(e) => playlistPlatformChangeHandler(e, playlistSongLibrary)}
                onBlur={(e) => playlistPlatformChangeHandler(e, playlistSongLibrary)}
                className='w-100'
                label={playlistSongLibrary?.streamingPlatformName}
                value={streamingLink}
                variant="filled"
                size="small"
                error={error}
                helperText={error ? "Please enter a valid URL" : ""}
              />
            </Box>

            <Box
              className='d-flex'
              sx={{
                flexDirection: 'column',
                alignItems: { xs: 'flex-end', sm: 'end' },
                marginLeft: { xs: 'auto', sm: 0 }
              }}
              gap={2}
            >
              <label className="switch">
                <input
                  checked={selectedStatus}
                  type="checkbox"
                  id={playlistSongLibrary?.id}
                  role="switch"
                  onChange={(e) => platformStatusChangeHandler(e, playlistSongLibrary?.id)}
                />
                <span
                  className="slider round"
                  style={{
                    opacity: selectedStatus === false && streamingLink === '' ? 0.3 : 1
                  }}
                  title={selectedStatus ? "Status True" : "Status False"}
                />
              </label>

              <IconButton onClick={() => deletePlatformHanlder(playlistSongLibrary?.id)}>
                <DeleteIcon sx={{ color: '#6c757d' }} />
              </IconButton>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>

  );
}

export default PlaylistPlatforms;
